export default {
    name: 'kendo-validator',
    bind (el, binding, vnode) {
        vnode.context.kendoValidator = kendo.jQuery(el).kendoValidator(binding.value).getKendoValidator()
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-validator-vue-wrapper/src/KendoValidator/index.js